import React, { Component } from 'react';
import HomeSettingsForm from '../../../components/SiteAdmin/HomeSettingsForm'
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import getAllHomePageSettings from './getAllHomePageSettings.graphql';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './HomeSettings.css';
import Loader from '../../../components/Common/Loader/Loader';

export class HomeSettings extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired
    }
    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { data: { loading, getAllHomePageSettings } } = this.props;
        let homepageCollection = {};
        getAllHomePageSettings && getAllHomePageSettings?.homePageData?.map((item) => {
            homepageCollection[item?.name] = item?.value
        });

        return (
            <Loader type={"page"} show={loading}>
                <div className={s.root}>
                    <div className={s.container}>
                        <div className={s.paddingRoutesSection}>
                            {!loading && <HomeSettingsForm initialValues={homepageCollection} />}
                        </div>
                    </div>
                </div>
            </Loader>
        )
    }
}

export default compose(withStyles(s), graphql(getAllHomePageSettings, {
    options: (props) => ({
        variables: {
            id: props.id
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
}))(HomeSettings)
